import * as _ from 'lodash';
import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {LoggerService} from "../../../common/logger.service";
import {UserService} from "../../../common/user.service";
import {BaseComponent} from "../../../base.component";
import {ShopSessionUtil} from "../shop-session-util";

@Component({
    selector: 'ssd-realtime-chart',
    templateUrl: './ssd-realtime-chart.component.html',
    styleUrls: ['./ssd-realtime-chart.component.scss'],
    standalone: false
})
export class SsdRealtimeChartComponent  extends BaseComponent implements OnChanges {

    @Input() shopSessionRealtimeList: any[] = [];
    @Input() shopSessionCountryRealtimeList: any[] = [];
    countryRealtime: any = [];

    public total: number = 0;

    public tooltipVisible: boolean = false;
    public selectedData: any = {};
    public tooltipX: number = 0;
    public tooltipY: number = 0;
    constructor(
        loggerService: LoggerService,
        userService: UserService,
    ) {
        super(userService, loggerService);
    }

    ngOnChanges(changes: SimpleChanges) {
        // this.log.debug("ssd-realtime-chart.component.ts ngOnChanges", changes);
        if(changes.shopSessionRealtimeList && this.shopSessionRealtimeList) {
            for(let i = 0; i < 30; i++) {
                if(!_.find(this.shopSessionRealtimeList, ["minutesBack", i])){
                    this.shopSessionRealtimeList.push({minutesBack: i, sessionCount: 0});
                }
            }

            //use lodash to sort the shopSessionRealtimeList by minutesBack, descending
            this.shopSessionRealtimeList = _.orderBy(this.shopSessionRealtimeList, ['minutesBack'], ['desc']);

            this.countryRealtime = ShopSessionUtil.createCountryRealtime(this.shopSessionCountryRealtimeList);

            this.calculateTotal();

            this.log.debug("shopSessionRealtimeList", this.shopSessionRealtimeList);
        }
    }

    getMaxSessionMinuteCount() {
        return Math.max(...this.shopSessionRealtimeList?.map(d => Math.max(d.sessionCount || 1)));
    }

    private calculateTotal() {
        this.total = this.countryRealtime.reduce((sum, data) => sum + data.sessions, 0);
    }

    public onMouseOver(selectedData: any, event: MouseEvent) {
        this.selectedData = selectedData;
        this.tooltipVisible = true;
    }

    public onMouseOut() {
        this.tooltipVisible = false;
    }

    public onMouseMove(event: MouseEvent) {
        // Offset tooltip position slightly from cursor
        this.tooltipX = event.clientX + 10;
        this.tooltipY = event.clientY + 10;
    }

    getBarStyle(value: number, property: string): any {
        return ShopSessionUtil.getBarStyle( this.countryRealtime, value, property);
    }
}
